<template>
    <div class="flex flex-col">
        <slot  />
    </div>
</template>

<script>
    export default {
        data() {
            return {
                
            }
        },
    }
</script>
